import { useState, useEffect } from 'react'

import { subscribeToGifs } from '../services/gifService'
import type { Gif } from '../types/gif.types'

interface UseGifsState {
  gifs: Gif[]
  loading: boolean
  error: string | null
}

export const useGifs = (): UseGifsState => {
  const [state, setState] = useState<UseGifsState>({
    gifs: [],
    loading: true,
    error: null,
  })

  useEffect(() => {
    setState((prev) => ({ ...prev, loading: true, error: null }))

    const unsubscribe = subscribeToGifs(
      (gifs) => {
        setState({
          gifs,
          loading: false,
          error: null,
        })
      },
      (error) => {
        setState((prev) => ({
          ...prev,
          loading: false,
          error: error.message,
        }))
      }
    )

    // Cleanup function to unsubscribe when component unmounts
    return () => {
      unsubscribe()
    }
  }, [])

  return state
}
